export default __webpack_public_path__ + "static/media/switch.e2ffb2ab.svg";